export default __webpack_public_path__ + "static/media/twint-logo.01529570.png";